// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const PARAMETER_OPTIMIZATION_MODELING_STEP_SHAPES = [
  {
    stepType: PipelineStepType.PARAMETER_OPTIMIZATION_MODELING,
    isDeprecated: true,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      'Model training input': {
        systemName: 'Model training input',
        displayName: 'Model training input',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: true
      },
      'All data': {
        systemName: 'All data',
        displayName: 'All data',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Feature importance': {
        systemName: 'Feature importance',
        displayName: 'Feature importance',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'SHAP values': {
        systemName: 'SHAP values',
        displayName: 'SHAP values',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Model evaluation': {
        systemName: 'Model evaluation',
        displayName: 'Model evaluation',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Search rankings': {
        systemName: 'Search rankings',
        displayName: 'Search rankings',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      'Feature data': {
        systemName: 'Feature data',
        displayName: 'Feature data',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      'Feature descriptions': {
        systemName: 'Feature descriptions',
        displayName: 'Feature descriptions',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      'Label data': {
        systemName: 'Label data',
        displayName: 'Label data',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      'Label description': {
        systemName: 'Label description',
        displayName: 'Label description',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      exclusion_reasons: {
        systemName: 'exclusion_reasons',
        displayName: 'exclusion_reasons',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      }
    },
    config: {
      datasetConfiguration: {
        kind: 'anything',
        required: true
      },
      dataDefinitionConfig: {
        kind: 'anything',
        required: true
      }
    }
  },
  {
    stepType: PipelineStepType.PARAMETER_OPTIMIZATION_MODELING,
    isDeprecated: true,
    version: 1,
    inputDataShapes: {
      'Feature data': {
        systemName: 'Feature data',
        displayName: 'Feature data',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Label data': {
        systemName: 'Label data',
        displayName: 'Label data',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'All data': {
        systemName: 'All data',
        displayName: 'All data',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Feature importance': {
        systemName: 'Feature importance',
        displayName: 'Feature importance',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'SHAP values': {
        systemName: 'SHAP values',
        displayName: 'SHAP values',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Model evaluation': {
        systemName: 'Model evaluation',
        displayName: 'Model evaluation',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Search rankings': {
        systemName: 'Search rankings',
        displayName: 'Search rankings',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      exclusion_reasons: {
        systemName: 'exclusion_reasons',
        displayName: 'exclusion_reasons',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      }
    },
    config: null
  },
  {
    stepType: PipelineStepType.PARAMETER_OPTIMIZATION_MODELING,
    isDeprecated: true,
    version: 2,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'All data': {
        systemName: 'All data',
        displayName: 'All data',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Feature importance': {
        systemName: 'Feature importance',
        displayName: 'Feature importance',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'SHAP values': {
        systemName: 'SHAP values',
        displayName: 'SHAP values',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Model evaluation': {
        systemName: 'Model evaluation',
        displayName: 'Model evaluation',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Search rankings': {
        systemName: 'Search rankings',
        displayName: 'Search rankings',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Predictions default values': {
        systemName: 'Predictions default values',
        displayName: 'Predictions default values',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Predictions grid': {
        systemName: 'Predictions grid',
        displayName: 'Predictions grid',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Extra data frames': {
        systemName: 'Extra data frames',
        displayName: 'Extra datasets',
        kind: PipelineStepDataKind.DATASET,
        isMulti: true,
        isRequired: false
      },
      'Extra charts': {
        systemName: 'Extra charts',
        displayName: 'Extra charts',
        kind: PipelineStepDataKind.CHART,
        isMulti: true,
        isRequired: false
      }
    },
    config: null
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
